import { idealistRedirect } from '#/routing/utils/idealistRedirect';

import { authLoginRoute } from './auth.routes';

type Args = {
  request: Request;
};

export function idealistRequireAuthentication({ request }: Args) {
  const url = new URL(request.url);

  return idealistRedirect({
    request,
    to: authLoginRoute.with({
      to: `${url.pathname}${url.search}`,
      auth_required: 1,
    }),
    status: 302,
  });
}
